function circleImageInit() {
    var circleImageSliderEl = $('.sunny__circle-images .circle-images-slider-wrapper')
    if (circleImageSliderEl) {
        circleImageSliderEl.flickity({
            // options
            pageDots: true,
            contain: true,
            prevNextButtons: false,
            wrapAround: true,
            adaptiveHeight: true,
            watchCSS: true,
            cellAlign: 'left'
        })
    }
}

document.addEventListener('DOMContentLoaded', function() {
    circleImageInit();
})